<template>
  <menu-item label="" tooltip-key="tooltip_wheels" v-if="tank.wheels_id">
    <custom-checkbox
        v-model="wheels"
        :label="$t('powerpack.valveMenu.wheels')"
    ></custom-checkbox>
  </menu-item>
</template>

<script>
  import MenuItem from './MenuItem'
  import CustomCheckbox from "@/components/input/Checkbox";
  import {mapGetters, mapState} from "vuex";

  export default {
    name: 'WheelsCheckbox',

    components: {
      MenuItem,
      CustomCheckbox,
    },

    computed: {
      ...mapGetters({
        tank: 'build/getTank',
      }),
      ...mapState('build', {
        hasWheels: (state) => state.wheels,
      }),
      wheels: {
        get() {
          return this.hasWheels;
        },
        set(val) {
          this.$store.commit('build/setWheels', val)
        }
      },
    },
  }
</script>
